exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wa-link p[data-v-5d4c9d16]{font-size:13px;line-height:1.5}.wa-link button[data-v-5d4c9d16]{padding:9px 12px;border:1px solid #9cb9a8;border-radius:5px;background:#eef5f1;color:#1b5e39;cursor:pointer}.wa-link input[data-v-5d4c9d16]{box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d4c9d16","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/chat/ChatWhatsAppPanel.vue
// module id = 362
// module chunks = 135